import { render, staticRenderFns } from "./AllRestoreTasks.vue?vue&type=template&id=7deec801&"
import script from "./AllRestoreTasks.vue?vue&type=script&lang=ts&"
export * from "./AllRestoreTasks.vue?vue&type=script&lang=ts&"
import style0 from "./AllRestoreTasks.vue?vue&type=style&index=0&id=7deec801&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports